import * as React from "react";
import { createPortal } from "react-dom";

// Fixed dialogs must not inherit a page's transformed/clipped containing block.
export function ModalViewport({ as: Element = 'div', children, ...props }) {
  return createPortal(<Element {...props}>{children}</Element>, document.body);
}

export function ModalViewportMetrics() {
  React.useLayoutEffect(() => {
    const root = document.documentElement;
    const viewport = window.visualViewport;
    const names = ['--app-viewport-height', '--app-viewport-width', '--app-viewport-top', '--app-viewport-left'];
    const previous = names.map(name => root.style.getPropertyValue(name));
    let frame;
    const update = () => {
      // visualViewport excludes browser controls and the on-screen keyboard.
      const values = [viewport?.height ?? window.innerHeight, viewport?.width ?? root.clientWidth,
        viewport?.offsetTop ?? 0, viewport?.offsetLeft ?? 0];
      names.forEach((name, index) => root.style.setProperty(name, `${values[index]}px`));
    };
    const schedule = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
    update();
    window.addEventListener('resize', schedule);
    viewport?.addEventListener('resize', schedule);
    viewport?.addEventListener('scroll', schedule);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', schedule);
      viewport?.removeEventListener('resize', schedule);
      viewport?.removeEventListener('scroll', schedule);
      names.forEach((name, index) => previous[index] ? root.style.setProperty(name, previous[index]) : root.style.removeProperty(name));
    };
  }, []);
  return null;
}
